import { createStore, applyMiddleware } from "redux";
import { composeWithDevTools } from "redux-devtools-extension";
import thunk from "redux-thunk";
import reducers from "./reducers/index";

// const  store = createStore(reducers,{});
const middleware = [thunk];
const store = createStore(
  reducers /* preloadedState, */,
  composeWithDevTools(applyMiddleware(...middleware))
);

export default store;
